import React from "react";
import Accordion from "react-bootstrap/Accordion";

/*eslint-disable */

interface DestacadasPageProps {
  fichasData: any;
}

declare const window: any;
const AccordionComponent: React.FC<DestacadasPageProps> = ({ fichasData }) => {
  return (
    <div className="hojas-rescate-accordion-component">
      <Accordion defaultActiveKey="0">
        {fichasData?.map((item: any, index: any) => (
          <Accordion.Item eventKey={`${index}`} key={index}>
            <Accordion.Header>{item?.vehicle}</Accordion.Header>
            <Accordion.Body>
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-4 col-rescate">
                  <img
                    src={`https://manager.hyundaicolombia.co/${item?.image?.url}`}
                    alt={item?.vehicle ? `Imagen de ${item.vehicle}` : "Imagen del vehículo"}
                    className="img-ficha-rescate"
                  />
                </div>
                <div className="col-sm-12 col-md-5 col-rescate">
                  <div className="txt-ficha-rescate">
                    {item?.rescue_sheet_name_english}
                  </div>
                  <div className="txt-ficha-rescate">
                    {item?.rescue_sheet_name_spanish}
                  </div>
                </div>
                <div className="col-sm-12 col-md-3 col-rescate">
                  <a
                    target="_blank"
                    href={`https://manager.hyundaicolombia.co${item?.rescue_sheet_pdf_english[0]?.url}`}
                    className="btn-ficha-rescate"
                  >
                    Ver documento
                  </a>
                  <a
                    target="_blank"
                    href={`https://manager.hyundaicolombia.co${item?.rescue_sheet_pdf_spanish?.url}`}
                    className="btn-ficha-rescate"
                  >
                    Ver documento
                  </a>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default AccordionComponent;